var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'button-full-width__container',
    _vm.buttonColor === 'brown' ? '--btn-brown' : '--btn-white'
  ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-full-width__content"},[_vm._t("icon"),_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }